import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import SchoolSwitcher from "./components/SchoolSwitcher";

import PageTitle from "./pages/PageTitle";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AddStudent from "./pages/AddStudent";
import ViewStudent from "./pages/ViewStudent";
import StudentDetails from "./pages/StudentDetails";
import StudentBill from "./pages/StudentBill";
import AllStudentBill from "./pages/AllStudentBill";
import StaffWallet from "./pages/StaffWallet";
import AdminWallet from "./pages/AdminWallet";
import WalletHistory from "./pages/WalletHistory";
import Notice from "./pages/Notice";
import ProductCategory from "./pages/ProductCategory";
import ProductSubcategory from "./pages/ProductSubcategory";
import Product from "./pages/Product";
import ProductVariant from "./pages/ProductVariant";
import ProductStock from "./pages/ProductStock";
import ProductBundleCreate from "./pages/ProductBundleCreate";
import ProductBundleList from "./pages/ProductBundleList";
import ProductBundleView from "./pages/ProductBundleView";
import SubjectPage from "./pages/SubjectPage";
import ClassSubjectAssignPage from "./pages/ClassSubjectAssignPage";
import TeacherManagementPage from "./pages/TeacherManagementPage";
import TeacherSubjectAssignPage from "./pages/TeacherSubjectAssignPage";

import "./App.css";
import "./index.css";

function App() {
  return (
    <Router basename="/app">
      <PageTitle />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />

        {/* Protected Admin routes with Layout */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route
            index
            element={
              <>
                <div style={{ display: "flex", justifyContent: "flex-end", padding: 8 }}>
                  <SchoolSwitcher />
                </div>
                <Dashboard />
              </>
            }
          />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="add-student" element={<AddStudent />} />
          <Route path="view-student" element={<ViewStudent />} />
          <Route path="view-student-details/:encodedId" element={<StudentDetails />} />
          <Route path="student-billing" element={<StudentBill />} />
          <Route path="all-billing" element={<AllStudentBill />} />
          <Route path="staff/wallet" element={<StaffWallet />} />
          <Route path="wallet" element={<AdminWallet />} />
          <Route path="wallet-history" element={<WalletHistory />} />
          <Route path="notice" element={<Notice />} />
          <Route path="product-category" element={<ProductCategory />} />
          <Route path="product-sub-category" element={<ProductSubcategory />} />
          <Route path="product" element={<Product />} />
          <Route path="product-variant" element={<ProductVariant />} />
          <Route path="stock-add" element={<ProductStock />} />
          <Route path="product-bundle/create" element={<ProductBundleCreate />} />
          <Route path="product-bundle/list" element={<ProductBundleList />} />
          <Route path="product-bundle/view/:id" element={<ProductBundleView />} />
          <Route path="subject-add" element={<SubjectPage />} />
          <Route path="subject-class/assign" element={<ClassSubjectAssignPage />} />
          <Route path="teacher-add" element={<TeacherManagementPage />} />
          <Route path="teacher-subject/assign" element={<TeacherSubjectAssignPage />} />

          {/* fallback */}
          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Route>

        {/* Fallback for unknown */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
